import { MDBBadge, MDBInput, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit';
//import { MDBBadge, MDBBtn, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit';
import { useContext, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import api from '../../app/api/agent'
import { GlobalStateContext } from '../../store/GlobalState';
import CustomNavBar from '../../components/CustomNavBar';
import SimpleDialogSuccess from '../../components/DialogSuccess';
import React from 'react';
import { alpha, Box, Button, createTheme, Dialog, TextField, Typography, Stack, MenuItem } from '@mui/material';
import EditAccountValid from '../../function/EditAccountValid';
//import Cookies from 'js-cookie';

function AdminList() {

    const [pageRecord, setPageRecord] = useState<Array<{ [x: string]: any }>[] | undefined>(undefined)
    const [recordList, setRecord] = useState<Array<{ [x: string]: any }>| undefined>(undefined)
    const [pageNum, setPageNum] = useState(1)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [pageSize, setPageSize] = useState(10)
    const [sortOrder, setsortOrder] = useState(false)
    const [sortedBy, setsortedBy] = useState("Company")
    const [TotalRecord, setTotalRecord] = useState(0)

  
    const [openSuccessActivate, setOpenSuccessActivate] = useState(false);

    enum userRoleList {
        CustomerService,                
        CastcoEmployee,
        Customer
    }
    
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [error, setError] = useState<string | null>(null);
    const [errorGeneral, setErrorGeneral] = useState<boolean | null>(null);
    const [errorEmail, setErrorEmail] = useState<boolean | null>(null);
    const [errorCompany, setErrorCompany] = useState<boolean | null>(null);
    const [errorPhoneNumber, setErrorPhoneNumber] = useState<boolean | null>(null);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [errorhelperText, setErrorHelperText] = useState<string | null>(null);
    

    const [isLoadingCreate, setIsLoadingCreate] = useState(false);
    

    const [openSuccess, setOpenSuccess] = useState(false);

    const handleClickOpenSuccessActivate = () => {
      setOpenSuccessActivate(true);
      setOpenConfirm(false);
    };

    const handleCloseSuccessActivate = () => {
      setOpenSuccessActivate(false);
      getRecord();
    };

    const globalState = useContext(GlobalStateContext);
    useEffect(()=>{

        if(localStorage.accessToken){
            api.get(`/Account/userInfo`).then((response)=>{
                    if (response.status !== 200){
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")
                        globalState?.setAccessToken('');
                        window.location.href='/'
                    }else{
                      /* if(response.data.role.toString() !== "0"){
                          window.location.href='/'
                      } */
                    }
                    }).catch(()=>{
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")

                        globalState?.setAccessToken('');
                        window.location.href='/'
                    })
        }else{
          api.get("/OIDC/getUserInfo",{withCredentials: true,}).then((response)=>{
                              if (response.status !== 200){
                                      window.location.href='/'
                              }else{
                                /* if(response.data.role.toString() !== "0"){
                                    window.location.href='/'
                                } */
                              }
                              }).catch(()=>{
                                  window.location.href='/'
                          })
        }
        if(localStorage.getItem("role") === "0"){
          getRecord()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[sortOrder, sortedBy, pageNum])

    useEffect(()=>{
        setPageNum(pageNum)
    },[pageNum])

    useEffect(()=>{
        getUserRoles();
    },[])

    const [options, setOptions] = useState<Array<{ [x: string]: any }>>([]);

    const getUserRoles = async () =>{
      if(localStorage.accessToken){
        await api.get(`/Admin/role/list`).then((response)=>{
          setOptions(response.data);
        })
      }else{
        await api.get(`/Admin/role/list`,{withCredentials: true,}).then((response)=>{
          setOptions(response.data);
        })
      }
    }

    const getRecord=async ()=>{
      const [listFilter, listValue]= getFilterAndValueList();
      if(localStorage.accessToken){
        await api.post(`/Admin/account/list`,{sortMethod: sortedBy, isASC: sortOrder, filterBy: listFilter, value: listValue, pageNo: pageNum, pageSize: pageSize}).then((response)=>{
            setRecord(response.data["items"])
            pageSeperate(response.data["items"])
            setTotalRecord(response.data["totalCount"])
        })
      }else{

        await api.post(`/Admin/account/list`,{sortMethod: sortedBy, isASC: sortOrder, filterBy: listFilter, value: listValue, pageNo: pageNum, pageSize: pageSize},{withCredentials: true,}).then((response)=>{
            setRecord(response.data["items"])
            pageSeperate(response.data["items"])
            setTotalRecord(response.data["totalCount"])
        })
      }
    }
    const pageSeperate = (records: Array<{ [x: string]: any }>) =>{
        var i = 0;
        var tempList: Array<{ [x: string]: any }>[] = []
        records?.forEach((record, index)=>{
            if(tempList[i] === undefined){tempList[i]=[]}
            tempList[i].push(record)
            if((index+1)%10 ===0){i+=1}
        })
        setPageRecord(tempList)
    }

    /* useEffect(()=>{
        //getRecord();
        if(pageRecord != null)
       setRecord(pageRecord[pageNum - 1])
    },[pageNum, pageRecord]) */


const [OpenConfirm, setOpenConfirm] = useState(false)
const [isActiveConfirm, setIsActiveConfirm] = useState(false)
const [idConfirm, setIdConfirm] = useState("")
const [nameConfirm, setNameConfirm] = useState("")
const [emailConfirm, setEmailConfirm] = useState("")
const [phoneConfirm, setPhoneConfirm] = useState("")
const [companyConfirm, setCompanyConfirm] = useState("")
      
const handleActive = (id: string, name: string, email: string, phone: string, company: string, isActive: boolean, roleId: number) => {

    setOpenConfirm(true);
    setIsActiveConfirm(isActive);
    setIdConfirm(id);
    setNameConfirm(name);
    setEmailConfirm(email);
    setPhoneConfirm(phone);
    setCompanyConfirm(company);
    setRoleId(roleId);
    };


        const [Open, setOpen] = useState(false)
        const [tempId, setTempId] = useState("")
        const [tempName, setTempName] = useState("")
        const [tempEmail, setTempEmail] = useState("")
        const [tempPhone, setTempPhone] = useState("")
        const [tempCompany, setTempCompany] = useState("")
        const [tempRoleId, setTempRoleId] = useState<number>()
        const [tempIsActive, setTempIsActive] = useState<boolean>(false)

        const [FullName, setFullName] = useState("")
        const [Email, setEmail] = useState("")
        const [Phone, setPhone] = useState("")
        const [Company, setCompany] = useState("")
        const [RoleId, setRoleId] = useState<number>()
    
        const handleClickOpen = (id: string, name: string, email: string, phone: string, company: string, isActive: boolean, roleId: number) => {
          setTempId(id);
          setTempName(name);
          setTempEmail(email);
          setTempPhone(phone);
          setTempCompany(company);
          setTempRoleId(roleId);
          setTempIsActive(isActive);
          setOpen(true);
        };
    
        const handleClose = () => {
          setOpen(false);
        };
    
    const theme = createTheme({
            palette: {
                primary: {
                    main: '#2e7d32',
                  },
            },
          });
          
    const EnterKeyOnClickCreate = (event: React.KeyboardEvent) => {
        if (event.key === "Enter") {
        handleEdit();
        }
    };
    

    const handleClickOpenSuccess = () => {
        setOpenSuccess(true);
    };

    const handleCloseSuccess = () => {
        setOpenSuccess(false);
        window.location.reload()
    };

    const handleEdit = async () => {
        //   if (!email || !password) {
        //     setError("Please enter both email and password");
        //     return;
        //   }
      
          try {
            setIsLoadingCreate(true);
            setError(null);
            setErrorEmail(null)
            setErrorCompany(null)
            setErrorPhoneNumber(null)
            setErrorGeneral(null)
    
            var errorMsg = "";
            errorMsg = EditAccountValid.checkCreateAccount(tempName, tempCompany, tempEmail, tempPhone, errorMsg);
    
            if(errorhelperText !== null){
              errorMsg += errorhelperText
            }
    
            if(errorMsg !== ""){
              setError(errorMsg)
              if(errorMsg.includes("email")){
                setErrorEmail(true)
              }
              if(errorMsg.includes("company")){
                setErrorCompany(true)
              }
              if(errorMsg.includes("phone number")){
                setErrorPhoneNumber(true)
              }
            }
            else{
              api.put("/Admin/account/edit", {id: tempId, name: tempName, company: tempCompany, email: tempEmail, phoneNumer: tempPhone, roleId: tempRoleId, isActive: tempIsActive}).then((response)=>{
                      if (response.status !== 200){
                        if(response.data["Email"] === "Email already exists"){
                          setError("Email already exists. \n 電子郵件已註冊 \n");
                          setErrorEmail(true)
                        }else{
                          setError("Edit Account failed. \n 更改帳戶失敗 \n");
                          setErrorGeneral(true)
                        }
                          
                      }else{
                        handleClickOpenSuccess();
                        handleClose();
                      }
                  }).catch((ex: any)=>{
                      if(ex.response.data["Email"]){
                        if(ex.response.data["Email"][0] === "Email already exists"){
                          setError("Email already exists. \n 電子郵件已註冊 \n");
                          setErrorEmail(true)
                        }else{
                          setError("Edit Account failed. \n 更改帳戶失敗 \n");
                          setErrorGeneral(true)
                        }
                      }else{
                        setError("Edit Account failed. \n 更改帳戶失敗 \n");
                        setErrorGeneral(true)
                      }
                  })
              
            }
          } catch (ex: any) {
            setError(
              ex.data?.message || "Edit Account failed. \n 更改帳戶失敗 \n"
            );
          } finally {
            setIsLoadingCreate(false);
          }
        };
  
  const getFilterAndValueList = ()=>{
    var listFilter = []
    var listValue = []
    if(FullName !== ""){
      listFilter.push("Name")
      listValue.push(FullName)
    }
    if(Email !== ""){
      listFilter.push("Email")
      listValue.push(Email)
    }
    if(Company !== ""){
      listFilter.push("Company")
      listValue.push(Company)
    }
    if(Phone !== ""){
      listFilter.push("PhoneNumber")
      listValue.push(Phone)
    }
    return [listFilter, listValue]
  }

  const handleSearch=async ()=>{
      getRecord();
  }

    const setSortByAndSortOrder= (SortBy: string)=>{
        /* if(sortedBy !== SortBy){
          setsortedBy(SortBy)
          setsortOrder("Desc")
        }else{
          if(sortOrder === "Desc"){
            setsortOrder("Asc")
          }else{
            setsortOrder("Desc")
          }
        } */
        if(sortedBy !== SortBy){
          setsortedBy(SortBy)
          setsortOrder(false)
          setPageNum(1)
        }else{
          if(sortOrder === false){
            setsortOrder(true)
            setPageNum(1)
          }else{
            setsortOrder(false)
            setPageNum(1)
          }
        }
    }

  return (
    <Container className="table-responsive" style={{minWidth: "770px",padding: 0, fontFamily:"Poppins", width:"95%", height:"100vh", background:"linear-gradient(45deg,rgba(255, 255, 255, 1) 0%, rgba(245, 255, 247, 1) 50%, rgba(222, 255, 232, 1) 100%)"}}>
    <CustomNavBar></CustomNavBar>
    
    
    {localStorage.getItem("role") !== "0" && 
          <><div>404 not found</div></>
    }

    
    {localStorage.getItem("role") === "0" && 
          <>
    <div  className='search-fields-wrapper'>
      <MDBInput onChange={(e) => setFullName(e.target.value)} label="Full Name" id="FullName" type="text" />
      <MDBInput onChange={(e) => setEmail(e.target.value)} label="Email" id="Email" type="text" />
      <MDBInput onChange={(e) => setPhone(e.target.value)} label="Phone" id="Phone" type="text" />
      <MDBInput onChange={(e) => setCompany(e.target.value)} label="Company" id="Company" type="text" />
      <span onClick={()=>{handleSearch()}} style={{cursor:"pointer", color:"blue", fontSize:"15px", marginLeft:"auto"}}>
          <MDBBadge className='badge' color='success' pill style={{fontSize:"18px"}}>
            Search
          </MDBBadge>
      </span>
    </div>
    {/* <Table striped bordered hover responsive size='sm'> */}
    <MDBTable align='middle' className="table table-hover" style={{width:"95%", margin:"auto"}}>
      {/* <thead style={{borderBottom:"12px"}}> */}
      <MDBTableHead>
        <tr className='table-success'>
          <th>Full Name</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Company</th>
          <th>Active</th>
          <th>Edit</th>
        </tr>
      {/* </thead> */}
      </MDBTableHead>
      <MDBTableBody>
      {/* <tbody> */}
      {recordList === undefined || recordList === null ? <></>: recordList.map((record, recordIndex)=>{
            return<React.Fragment key={record["id"]}>
                <tr>
                <td>{record["name"] !== null ? record["name"].toString() : ""}</td>
                <td>{record["email"] !== null ? record["email"].toString() : ""}</td>
                <td>{record["phoneNumer"] !== null ? record["phoneNumer"].toString() : ""}</td>
                <td>{record["company"] !== null ? record["company"].toString() : ""}</td>
                <td>
                <span onClick={()=>{handleActive(record["id"], record["name"], record["email"], record["phoneNumer"], record["company"], record["isActive"], Number(userRoleList[record["roleId"]]))}} style={{cursor:"pointer", color:"blue", fontSize:"15px"}}>
                    <MDBBadge className='badge' color='success' pill style={{fontSize:"14px"}}>
                    {record["isActive"] === false ? "Activate" : "Deactivate"}
                    </MDBBadge>
                </span>
                {/* <MDBBtn onClick={()=>{handleClickOpen(record["id"])}} style={{cursor:"pointer"}} color='link' rounded size='sm'>
                    Approve
                </MDBBtn> */}
                    {/* <button onClick={(e)=>openRecordTab(record["contracT_NO"].toString())} style={{cursor:"pointer"}}>View</button> */}
                </td>
                <td>
                    <span onClick={()=>{handleClickOpen(record["id"], record["name"], record["email"], record["phoneNumer"], record["company"], record["isActive"], Number(userRoleList[record["roleId"]]))}} style={{cursor:"pointer", color:"blue", fontSize:"15px"}}>
                        <MDBBadge className='badge' color='success' pill style={{fontSize:"14px"}}>
                        Edit
                        </MDBBadge>
                    </span>
                </td>
                </tr></React.Fragment>
      })}
        {/* <tr className='bg-white'>
          <td>2</td>
          <td>Jacob</td>
          <td>Thornton</td>
          <td><MDBBadge color='success' pill>
              Awaiting
            </MDBBadge></td>
          <td>
          <MDBBtn onClick={()=>{handleClickOpen("0")}} style={{cursor:"pointer"}} color='link' rounded size='sm'>
                    Approve
          </MDBBtn>
            </td>
        </tr>
        <tr className='table-success'>
          <td>3</td>
          <td>Larry the Bird</td>
          <td>@mdo</td>
          <td>@twitter</td>
          <td>
          <MDBBtn onClick={()=>{handleClickOpen("0")}} style={{cursor:"pointer"}} color='link' rounded size='sm'>
                    Approve
          </MDBBtn>
            </td>
        </tr> */}
      {/* </tbody> */}
      
      </MDBTableBody>
    </MDBTable>
    {/* </Table> */}
    <div style={{marginTop:"20px", textAlign:"right", width:"90%", display:"flex", flexDirection:"row", justifyContent:"right"}}>
        <div style={{marginRight:"30px"}}>
            {/* <span style={{fontSize:"20px", verticalAlign:"middle"}}>{pageNum+1}-{pageRecord? (pageRecord[pageNum] ? pageRecord[pageNum].length : 0) : recordList?.length} OF {recordList?.length}</span> */}
            <span style={{fontSize:"20px", verticalAlign:"middle"}}>{TotalRecord === 0? 0 : 1 + (pageNum -1)* pageSize}-{(TotalRecord/pageSize > pageNum)? (pageNum) * pageSize: TotalRecord} OF {TotalRecord}</span>
        </div>
        <button onClick={(e)=>{(1 < pageNum)? setPageNum(pageNum-1): setPageNum(pageNum)}} style={{width:"30px", height:"inherit", cursor:"pointer"}}>&lt;</button>
        <button onClick={(e)=>{(TotalRecord/pageSize > pageNum)? setPageNum(pageNum+1): setPageNum(pageNum)}} style={{width:"30px", marginRight:"10px", height:"inherit", cursor:"pointer"}}>&gt;</button>    
    </div>

    <SimpleDialogSuccess openSuccess={openSuccessActivate} handleCloseSuccess={handleCloseSuccessActivate} messagetype='Activate'></SimpleDialogSuccess>
    <SimpleDialogSuccess openSuccess={openSuccess} handleCloseSuccess={handleCloseSuccess} messagetype='Activate'></SimpleDialogSuccess>


    <Dialog
            open={Open}
            onClose={handleClose}
          >
                  
                  <Box
                  sx={{
                    width: "20rem",
                    maxWidth: { xs: "100%", sm: 400 },
                    borderRadius: 2,
                    padding: { xs: 3, sm: 4 },
                  }}>
                  <Typography
                      variant="h4"
                      sx={{
                        fontSize: { xs: "1.5rem", sm: "2rem" },
                        fontWeight: 700,
                        color: theme.palette.primary.main,
                        letterSpacing: { xs: 1, sm: 2 },
                        textAlign: "center",
                        textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
                      }}
                    >
                      Confirm Or Edit
                    </Typography>
                    <TextField
                    autoComplete="off"
                    label="Company"
                    type="text"
                    value={tempCompany}
                    InputLabelProps={{ shrink: true }}  
                    onChange={(e) => {setTempCompany(e.target.value); setErrorCompany(null)}}
                    onKeyUp={EnterKeyOnClickCreate}
                    fullWidth
                    variant="outlined"
                    error={!!errorGeneral || !!errorCompany}
                    disabled={isLoadingCreate}
                    sx={{
                      mb: { xs: 2, sm: 3 },
                      "& .MuiOutlinedInput-root": {
                        borderRadius: { xs: "8px", sm: "12px" },
                        transition: "all 0.3s ease",
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: theme.palette.primary.main,
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: theme.palette.primary.main,
                          borderWidth: 2,
                        },
                      },
                      "& .MuiInputLabel-root": {
                        lineHeight: '1rem',
                        //color: theme.palette.primary.main,
                        "&.Mui-focused": { color: theme.palette.primary.main },
                      },
                      "& input": {
                        fontSize: { xs: "0.9rem", sm: "1rem" },
                        padding: { xs: "10px 12px", sm: "12px 14px" },
                      },
                    }}
                  />
                  <TextField
                    autoComplete="off"
                    label="Name"
                    type="text"
                    value={tempName}
                    InputLabelProps={{ shrink: true }}  
                    onChange={(e) => setTempName(e.target.value)}
                    onKeyUp={EnterKeyOnClickCreate}
                    fullWidth
                    variant="outlined"
                    error={!!errorGeneral}
                    disabled={isLoadingCreate}
                    sx={{
                      mb: { xs: 2, sm: 3 },
                      "& .MuiOutlinedInput-root": {
                        borderRadius: { xs: "8px", sm: "12px" },
                        transition: "all 0.3s ease",
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: theme.palette.primary.main,
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: theme.palette.primary.main,
                          borderWidth: 2,
                        },
                      },
                      "& .MuiInputLabel-root": {
                        lineHeight: '1rem',
                        //color: theme.palette.primary.main,
                        "&.Mui-focused": { color: theme.palette.primary.main },
                      },
                      "& input": {
                        fontSize: { xs: "0.9rem", sm: "1rem" },
                        padding: { xs: "10px 12px", sm: "12px 14px" },
                      },
                    }}
                  />
                  <TextField
                    autoComplete="tel"
                    label="Phone Number"
                    type="tel"
                    value={tempPhone}
                    InputLabelProps={{ shrink: true }}  
                    onChange={(e) => {setTempPhone(e.target.value); setErrorPhoneNumber(null)}}
                    onKeyUp={EnterKeyOnClickCreate}
                    fullWidth
                    variant="outlined"
                    error={!!errorGeneral || !!errorPhoneNumber}
                    disabled={isLoadingCreate}
                    sx={{
                      mb: { xs: 2, sm: 3 },
                      "& .MuiOutlinedInput-root": {
                        borderRadius: { xs: "8px", sm: "12px" },
                        transition: "all 0.3s ease",
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: theme.palette.primary.main,
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: theme.palette.primary.main,
                          borderWidth: 2,
                        },
                      },
                      "& .MuiInputLabel-root": {
                        lineHeight: '1rem',
                        //color: theme.palette.primary.main,
                        "&.Mui-focused": { color: theme.palette.primary.main },
                      },
                      "& input": {
                        fontSize: { xs: "0.9rem", sm: "1rem" },
                        padding: { xs: "10px 12px", sm: "12px 14px" },
                      },
                    }}
                  />
                  <TextField
                    autoComplete="email"
                    label="Email"
                    type="email"
                    value={tempEmail}
                    InputLabelProps={{ shrink: true }}  
                    onChange={(e) => {setTempEmail(e.target.value); setErrorEmail(null)}}
                    onKeyUp={EnterKeyOnClickCreate}
                    fullWidth
                    variant="outlined"
                    error={!!errorGeneral || !!errorEmail}
                    disabled={isLoadingCreate}
                    sx={{
                      mb: { xs: 2, sm: 3 },
                      "& .MuiOutlinedInput-root": {
                        borderRadius: { xs: "8px", sm: "12px" },
                        transition: "all 0.3s ease",
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: theme.palette.primary.main,
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: theme.palette.primary.main,
                          borderWidth: 2,
                        },
                      },
                      "& .MuiInputLabel-root": {
                        lineHeight: '1rem',
                        //color: theme.palette.primary.main,
                        "&.Mui-focused": { color: theme.palette.primary.main },
                      },
                      "& input": {
                        fontSize: { xs: "0.9rem", sm: "1rem" },
                        padding: { xs: "10px 12px", sm: "12px 14px" },
                      },
                    }}
                  />
                  <TextField
                    label="Role"
                    value={tempRoleId}
                    select
                    InputLabelProps={{ shrink: true }}  
                    onChange={(e) => {setTempRoleId((Number(e.target.value)));}}
                    onKeyUp={EnterKeyOnClickCreate}
                    fullWidth
                    variant="outlined"
                    error={!!errorGeneral}
                    disabled={isLoadingCreate}
                    sx={{
                      mb: { xs: 2, sm: 3 },
                      "& .MuiOutlinedInput-root": {
                        borderRadius: { xs: "8px", sm: "12px" },
                        transition: "all 0.3s ease",
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: theme.palette.primary.main,
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: theme.palette.primary.main,
                          borderWidth: 2,
                        },
                      },
                      "& .MuiInputLabel-root": {
                        lineHeight: '1rem',
                        //color: theme.palette.primary.main,
                        "&.Mui-focused": { color: theme.palette.primary.main },
                      },
                      "& input": {
                        fontSize: { xs: "0.9rem", sm: "1rem" },
                        padding: { xs: "10px 12px", sm: "12px 14px" },
                      },
                    }}
                  >
                    {options === undefined || options === null ? <></>: options.map((value, index)=>{
                      return <MenuItem value={value.roleId}>{value.name}</MenuItem>
                    })}
                  </TextField>
                  <Button
                    variant="contained"
                    onClick={()=>{
                        handleEdit();
                    }}
                    fullWidth
                    sx={{
                      padding: { xs: "5px", sm: "6px" },
                      borderRadius: { xs: "20px", sm: "25px" },
                      background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                      textTransform: "none",
                      fontWeight: 500,
                      fontSize: { xs: "1rem", sm: "1.1rem" },
                      transition: "all 0.3s ease",
                      "&:hover": {
                        background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                        transform: "translateY(-2px)",
                        boxShadow: theme.shadows[4],
                      },
                      "&:focus": {
                        outline: `2px solid ${alpha(
                          theme.palette.primary.main,
                          0.5
                        )}`,
                        outlineOffset: "2px",
                      },
                    }}
                  >
                    Edit to Save
                  </Button>
                  </Box>
    
          </Dialog>




          <Dialog
                  open={OpenConfirm}
                  onClose={()=>{setOpenConfirm(false)}}
                >
                        
                        <Box
                        sx={{
                          width: "20rem",
                          maxWidth: { xs: "100%", sm: 400 },
                          borderRadius: 2,
                          padding: { xs: 3, sm: 4 },
                        }}>
                          <Typography
                            variant="h4"
                            sx={{
                              fontSize: { xs: "1.5rem", sm: "2rem" },
                              fontWeight: 700,
                              color: theme.palette.primary.main,
                              letterSpacing: { xs: 1, sm: 2 },
                              textAlign: "center",
                              textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
                            }}
                          >
                            Confirm
                          </Typography>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontSize: { xs: "0.9rem", sm: "1rem" },
                              mt: { xs: 1, sm: 2 },
                              fontWeight: 300,
                              opacity: 0.9,
                              textAlign: "center",
                              textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
                            }}
                          >
                          Confirm Activate or Deactivate?
                          </Typography>
                          <div className="mb-3"></div>
                          <Stack direction="row" spacing={2}>
                          <Button
                          variant="contained"
                          onClick={()=>{
                              
                                if(isActiveConfirm === false){
                                    api.put("/Admin/account/edit", {id: idConfirm, name: nameConfirm, company: companyConfirm, email: emailConfirm, phoneNumer: phoneConfirm, isActive: true, roleId: RoleId}).then(()=>{
                                                    handleClickOpenSuccessActivate();
                                    });
                                }else{
                                    api.put("/Admin/account/edit", {id: idConfirm, name: nameConfirm, company: companyConfirm, email: emailConfirm, phoneNumer: phoneConfirm, isActive: false, roleId: RoleId}).then(()=>{
                                                    handleClickOpenSuccessActivate();
                                    });
                                }
                          }}
                          fullWidth
                          sx={{
                            padding: { xs: "5px", sm: "6px" },
                            borderRadius: { xs: "20px", sm: "25px" },
                            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                            textTransform: "none",
                            fontWeight: 500,
                            fontSize: { xs: "1rem", sm: "1.1rem" },
                            transition: "all 0.3s ease",
                            "&:hover": {
                              background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                              transform: "translateY(-2px)",
                              boxShadow: theme.shadows[4],
                            },
                            "&:focus": {
                              outline: `2px solid ${alpha(
                                theme.palette.primary.main,
                                0.5
                              )}`,
                              outlineOffset: "2px",
                            },
                          }}
                        >
                          Yes
                        </Button>
                        <Button
                          className='ml-3'
                          variant="contained"
                          onClick={()=>{setOpenConfirm(false)}}
                          fullWidth
                          sx={{
                            padding: { xs: "50px", sm: "6px" },
                            borderRadius: { xs: "20px", sm: "25px" },
                            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                            textTransform: "none",
                            fontWeight: 500,
                            fontSize: { xs: "1rem", sm: "1.1rem" },
                            transition: "all 0.3s ease",
                            "&:hover": {
                              background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                              transform: "translateY(-2px)",
                              boxShadow: theme.shadows[4],
                            },
                            "&:focus": {
                              outline: `2px solid ${alpha(
                                theme.palette.primary.main,
                                0.5
                              )}`,
                              outlineOffset: "2px",
                            },
                          }}
                        >
                          No
                        </Button>
                        </Stack>
                        </Box>
          
                </Dialog>
    </>
    }

    
      <div className='bar-styles'>
        Steel Bar Form System &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Version: {process.env.REACT_APP_VERSION}
        <div style={{float:'right', marginRight: '40px'}}>
        </div>
      </div>
    </Container>
  );
}

export default AdminList;